import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {EmployeeService} from '../../../../employee.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {CovidService} from '../../../../services/covid.service';
import {FormBuilder, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {SignaturePad} from 'angular2-signaturepad/signature-pad';
import {environment} from '../../../../../environments/environment';
import {FilesService} from '../../../../services/files.service';
import { Router } from '@angular/router';
import { StationService } from '../../../../services/stations.service';
import { SysUsersService } from '../../../../services/sys-users.service';

@Component({
  selector: 'ngx-protection-equipment',
  templateUrl: './protection-equipment.component.html',
  styleUrls: ['./protection-equipment.component.scss'],
})
export class ProtectionEquipmentComponent implements OnInit {
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  @Input() stationId: string;
  downloading = false;

  constructor(
    private employeeService: EmployeeService,
    private covidService: CovidService,
    private formBuilder: FormBuilder,
    private filesService: FilesService,
    private router: Router,
    private stationService: StationService,
    private userService: SysUsersService,
  ) {
    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
  }

  user = { role: '' }
  dataInput = this.formBuilder.group({
    employeeId: ['', [Validators.required]],
    sign: [''],
    dateDelivery: [new Date()],
    supplie: this.formBuilder.group({
      id: [''],
      name: ['', [Validators.required]],
      detail: ['', [Validators.required]],
      quantity: ['', [Validators.required]],
      unitMeasurement: ['pieza', [Validators.required]],
    }),
  });
  signaturePadOptions = {
    'minWidth': 0.8,
    maxWidth: 1,
    'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
    'canvasWidth': document.documentElement.clientWidth * .36,
  };
  employees = [];
  supplies = [];
  employeeDataSelected = { role: '' };
  loading = false;
  token: any = '';
  formSubmitted = false;

  async ngOnInit() {
    this.init();
  }

  async init() {
    await this.getEmployeeStation();
    await this.getSupplies();
    await this.setUser();
  }

  async setUser () {
    const [error, response] = await this.userService.getProfileV2();
    if (error) return error;
    this.user = response.data;
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  async getEmployeeStation() {
    this.loading = true;
    const [err, response] = await this.employeeService.getEmployees(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops', 'error', 'Ocurrio un error al cargar la información, intenta más tarde por favor');
    this.employees = response.data;
  }

  async searchEmployeeSelected() {
    this.employeeDataSelected = this.employees.find((employee) => employee.id === this.dataInput.get('employeeId').value);
  }

  async getSupplies() {
    this.loading = true;
    const [err, response]: any = await this.covidService.getSupplies(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops', 'error', 'Ocurrio un error al cargar la información, intenta más tarde por favor');
    this.supplies = response.data.supplies;
  }

  async store() {
    this.formSubmitted = true;
    this.loading = true;
    await this.dataInput.get('sign').setValue(this.signaturePad.toDataURL());
    const [err] = await this.covidService.storeSuppliesDelivery(this.stationId, this.dataInput.value);
    this.loading = false;
    if (err) return this.alert('Oops', 'error', 'Ocurrio un error al intentar guardar la información, intenta más tarde por favor');
    await this.storeSupplie();
    this.dataInput.reset();
    this.formSubmitted = false;
    this.clearSignature();
    return this.alert('Éxito', 'success', 'Caso positivo guardado con éxito');
  }

  async storeSupplie() {
    const supplieName = this.dataInput.get('supplie.name').value.trim();
    const supplieExists = this.supplies.find((supplie) => supplie.name === supplieName);
    if (supplieExists) return;
    await this.covidService.storeSupplie(this.stationId, {name: supplieName});
    await this.getSupplies();
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async generateUrl() {
    this.downloading = true;
    await this.filesService.downloadFile(`${environment.baseEndpoint}/covid/download/${this.stationId}/team`);
    this.downloading = false;
  }

  // formattedDataForSearTypeHead(supplies: any) {
  //   const dataResponse = [];
  //   for (const supplie of supplies) dataResponse.push(supplie.name);
  //   return dataResponse;
  // }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        const supplies = this.supplies.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10);
        return supplies.map(supplie => supplie.name)
      }),
    )

}
